import React, {useState} from 'react';
import {get} from 'lodash';
import axios from 'axios';
import moment from 'moment';
import Waypoint from 'react-waypoint';
import className from 'classnames';

import {
  metaLoading,
  requestCallback,
} from '../lib/helpers';

import {useCheckIds} from '../hooks';

import Loading from './Loading';
import ModalDelete from './ModalDelete';
import UserDeviceTools from './UserDeviceTools';

const UserDevices = ({
  userId,
  resourceType,
  resourceId
}) => {
  const {
    checkIds,
    setCheckIds,
    renderCheckBox,
  } = useCheckIds({
    data: [],
    openUrl: 'devices',
  })

  const [devices, devicesSet] = useState({
    ...metaLoading,
    shouldFetch: true,
    data: [],
  })

  const clearPushInfo = (deviceId) => {
    requestCallback(axios.get(`/${gon.currentProvider}/api/devices/${deviceId}/clear_push_info`, {
      params: {
        user_id: userId
      }
    }))
  }

  const clearVoipPushInfo = (deviceId) => {
    requestCallback(axios.get(`/${gon.currentProvider}/api/devices/${deviceId}/clear_voip_push_info`, {
      params: {
        user_id: userId
      }
    }))
  }

  const _fetchData = () => {
    if (devices.shouldFetch) {
      axios.get(`/${gon.currentProvider}/api/devices`,{
        params: {
          resource_type: resourceType,
          resource_id: resourceId,
          user_id: userId
        }
      })
      .then((res) => {
        if (res.status == 200 && get(res, 'data')) {
          devicesSet({
            data: get(res, 'data.devices'),
            shouldFetch: false,
            meta: {
              isLoading: false
            }
          })
        }
      })
    }
  }

  return (
    <React.Fragment>
      <div className='User__header'>
        <h3 className='User__header__h3'>Devices</h3>
      </div>

      <div className='TableChecker TableChecker--ban'>
        <div className='TableChecker__left'>
          <div
            className='TableChecker__left__a'
          >
            <a
              onClick={() => {
                if (checkIds.length < get(devices, 'data.length', 0)) {
                  setCheckIds(get(devices, 'data', []).map((x) => x.id))
                }
                else {
                  setCheckIds([])
                }
              }}
              className={className('CheckBox', {
                'CheckBox--partial': checkIds.length > 0,
                'CheckBox--active': checkIds.length == get(devices, 'data.length') && get(devices, 'data.length') != 0,
              })}
            />

            <UserDeviceTools
              deviceIds={checkIds}
            />
          </div>
        </div>

        <div className='TableChecker__uuid'>
          <strong>Devices Count:</strong>

          {get(devices, 'data.length', 0)}
        </div>
      </div>

      <Waypoint onEnter={_fetchData}>
        <div className='Table Table--user-devices'>
          {(() => {
            const columnHeaders = [
              '', 'ID', 'Updated at', 'App version / Os version', 'UUID',
              'Push token', 'VOIP push token', 'End point ARN', 'AccessToken ID', 'Manage'
            ]

            return (
              <div className='Table__row'>
                {columnHeaders.map((value, key) => (
                  <div
                    key={key}
                    className='Table__col Table__col--th'
                  >
                    {value}
                  </div>
                ))}
              </div>
            )
          })()}

          <Loading
            isLoading={get(devices, 'shouldFetch') && get(devices, 'data.length', 0) == 0}
          >
            {get(devices, 'data', []).slice(0, 50).map((device) => (
              <div
                className={className('Table__row', {
                  'Table__row--active': checkIds.includes(device.id),
                })}
                key={device.id}
              >
                <div className='Table__col'>
                  {renderCheckBox(device)}
                </div>

                <div className='Table__col'>{device.id}</div>
                <div className='Table__col'>{moment(device.updatedAt).format('YYYY-MM-DD HH:mm')}</div>
                <div className='Table__col'>{device.appAndOsVersion}</div>
                <div className='Table__col'>
                  <p className='Table__code'>{device.uuid}</p>
                </div>
                <div className='Table__col'>
                  <p className='Table__code'>{device.pushToken}</p>

                  {gon.currentAdmin.isSuperAdmin &&
                    <a
                      className='Table__code__clear'
                      onClick={() => clearPushInfo(device.id)}
                    >
                      Clear push info
                    </a>
                  }
                </div>
                <div className='Table__col'>
                  <p className='Table__code'>{device.voipPushToken}</p>

                  {gon.currentAdmin.isSuperAdmin &&
                    <a
                      className='Table__code__clear'
                      onClick={() => clearVoipPushInfo(device.id)}
                    >
                      Clear VOIP push info
                    </a>
                  }
                </div>
                <div className='Table__col'>
                  <p className='Table__code'>{device.endpointArn}</p>
                </div>
                <div className='Table__col'>
                  <a
                    className='DotTooltip__link'
                    href={`/${gon.currentProvider}/access_tokens/${device.accessTokenId}`}
                  >
                    {device.accessTokenId}
                  </a>
                </div>

                <div className='Table__col'>
                  <div className='Table__controls'>
                    <ModalDelete
                      type='device'
                      id={device.id}
                      klassName='Table__controls__a Table__controls__a--trash'
                      reload
                      hideText
                    />
                  </div>
                </div>
              </div>
            ))}
          </Loading>
        </div>
      </Waypoint>
    </React.Fragment>
  );
}

export default UserDevices
